export default "__VITE_ASSET__DdCKXzDD__"